import { render, staticRenderFns } from "./BlacklistedChassisFormDetailed.vue?vue&type=template&id=49687a7a&"
import script from "./BlacklistedChassisFormDetailed.vue?vue&type=script&lang=js&"
export * from "./BlacklistedChassisFormDetailed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports